import styled from 'foundations-theming/utils';
import { memo } from 'react';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { List } from 'foundations-components/transitional/components/List';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PROPERTIES } from 'email-management-lib/Shared/constants/frameworkTable';
// @ts-expect-error not migrated to TS yet
import { TEAM, USER } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error not migrated to TS yet
import ResolveReferences from 'reference-resolvers/ResolveReferences';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFormattedMessage = styled(FormattedMessage).withConfig({
  displayName: "VisibleToCell__StyledFormattedMessage",
  componentId: "sc-1mn8bvu-0"
})(["color:", ";"], ({
  theme
}) => theme.color['do-not-use-calypso']);
export function VisibleToCell({
  accessList
}) {
  if (!accessList || accessList.length === 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "email-management.table.all"
    });
  }
  if (accessList.length === 1) {
    return /*#__PURE__*/_jsx("span", {
      children: accessList[0].label
    });
  }
  return /*#__PURE__*/_jsxs(TFlex, {
    direction: "row",
    children: [/*#__PURE__*/_jsx(View, {
      marginInlineEnd: "200",
      as: "span",
      children: accessList[0].label
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(List, {
        wrapChildren: true,
        children: accessList.slice(1).filter(list => list && list.label).map(a => a.label)
      }),
      children: /*#__PURE__*/_jsx(StyledFormattedMessage, {
        message: "email-management.table.extra",
        options: {
          extraNumber: accessList.length - 1
        }
      })
    })]
  });
}
const mapResolversToProps = (resolvers, props) => {
  const {
    crmObject
  } = props;
  const userIds = getPropertyValue(crmObject, PROPERTIES.USER_IDS);
  const teamIds = getPropertyValue(crmObject, PROPERTIES.TEAM_IDS);
  const accessList = [];
  if (teamIds) {
    const teams = teamIds.split(';').map(Number);
    accessList.push(...teams.map(team => resolvers[TEAM].byId(team)));
  }
  if (userIds) {
    const users = userIds.split(';').map(Number);
    accessList.push(...users.map(user => resolvers[USER].byId(user)));
  }
  if (accessList.length === 0) {
    return {};
  }
  return {
    accessList
  };
};
const ResolvedVisibleToCell = /*#__PURE__*/memo(ResolveReferences(mapResolversToProps)(VisibleToCell));
export default ResolvedVisibleToCell;